import { uniqueId } from "lodash";
import React, { useState } from "react";
import { FormGroup, Input, Tooltip } from "reactstrap";

function InputControl({ name, label, error, id = uniqueId(`${name}-`), displayValueWhenEmpty, ...rest }) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  const errorClass = error ? { borderColor: "#ff576c" } : {};
  const { tooltip, value, placeholder: placeholderProp, ...inputRest } = rest;

  const effectiveValue =
    (value === "" || value === null || value === undefined) && displayValueWhenEmpty !== undefined
      ? displayValueWhenEmpty
      : value;
  const tooltipElement = (
    <span>
      <i className="fa fa-question-circle" id={name} />
      <Tooltip placement="top" target={name} isOpen={tooltipOpen} toggle={toggle}>
        {tooltip}
      </Tooltip>
    </span>
  );
  return (
    <FormGroup>
      {label && (
        <label htmlFor={id}>
          {label} {tooltip && tooltipElement}
        </label>
      )}
      <Input
        {...inputRest}
        value={effectiveValue}
        name={name}
        id={id}
        placeholder={placeholderProp !== undefined ? placeholderProp : label}
        style={errorClass}
        onWheel={(event) => {
          if (event.target.type === "number") document.activeElement.blur();
        }}
      />
      {error && <div style={{ color: "#ff576c", fontSize: "12px" }}>{error}</div>}
    </FormGroup>
  );
}

export default InputControl;
